export default {"src":"/_next/static/media/XLight.b3c14d05.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};